import React from "react";
import "./CSS/style.css";
import "./CSS/media.css";
import TypeWriter from "react-typewriter";

function Hero() {
  return (
    <div className="hero container-fluid">
      <div className="container hero__container">
        <div className="row">
          <div className="col-md-12">
            <h6 className="hero__greeting">Hi, my name is</h6>
            <h1 className="hero__name">
              <TypeWriter typing={0.6}>Saud Khan</TypeWriter>
            </h1>
            <h1 className="hero__tagline">Interactive Front-end developer.</h1>
            <p className="hero__objective">
              I'm a full stack developer specializing in building (and
              occasionally designing) exceptional digital experiences.
              Currently, I'm focused on two projects with my team at{" "}
              <a target="_blank" href="https://property051.com/">
                Property051.
              </a>
              .
            </p>
            <a href="mailto:khansaud150@gmail.com" className="hero__button">
              Get In Touch
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
